import {
    call,
    select,
    all,
} from 'redux-saga/effects';
import {
    selectSelectedCountry,
    selectSelectedDestination,
} from '../selector';
import { trackIt } from '@vfde-sails/tracking';
import countries from '../../../fixtures/countries';

/**
 * initialTrackingSaga
 */
export function* initialTrackingSaga () {
    const trackinObject = createTrackingObject('1', 'goal', ['start']);
    yield call(trackIt, 'pageview', trackinObject);
}

/**
 * setDestinationTrackingSaga
 */
export function* setDestinationTrackingSaga () {
    const trackinObject = createTrackingObject('2', 'country');
    yield call(trackIt, 'pageview', trackinObject);
}

/**
 * setCountryTrackingSaga
 */
export function* setCountryTrackingSaga () {
    const trackinObject = createTrackingObject('3', 'current tariff');
    yield call(trackIt, 'pageview', trackinObject);
}

/**
 * setTariffTrackingSaga
 */
export function* setTariffTrackingSaga (args) {
    // get country and destination since this is not part of the arguments
    const [selectedCountry, selectedDestination] = yield all([
        select(selectSelectedCountry()),
        select(selectSelectedDestination()),
    ]);
    const countryName = txtNormalize(countries.find(country => country.countryCode === selectedCountry).name);
    const outcome = `${countryName}|${selectedDestination}|${args.tariff}`;
    const trackinObject = createTrackingObject('4', 'confirmation', ['end', 'success'], outcome);
    yield call(trackIt, 'pageview', trackinObject);
}

/**
 * txtNormalize
 * that should be moved somewhere else
 */
export const txtNormalize = (txtInput: string): string => {
    txtInput = txtInput.replace(/ä/g, 'ae');
    txtInput = txtInput.replace(/Ä/g, 'Ae');
    txtInput = txtInput.replace(/ö/g, 'oe');
    txtInput = txtInput.replace(/Ö/g, 'Oe');
    txtInput = txtInput.replace(/ü/g, 'ue');
    txtInput = txtInput.replace(/Ü/g, 'Ue');
    txtInput = txtInput.replace(/ß/g, 'ss');
    // eslint-disable-next-line no-useless-escape
    txtInput = txtInput.replace(/[\(\)]/g, '');
    txtInput = txtInput.replace(/é/g, 'e');

    return txtInput;
};

/**
 * createTrackingObject
 * @param formStep - step as string starting with 1 e.g. '1', '2', '3'
 * @param formStepName - step name as string e.g. "goal" , "country", "current tariff", "confirmation"
 * @param formStatus - array of string indicating the current step e.g. [], ["start"], ["end","success"], ["end","failure"]
 * @param outcome - pipe seperated string of user inputs e.g. "afghanistan|von deutschland ins ausland telefonieren|smart"
 * @returns  - the tracking obect
 */
export const createTrackingObject = (
    formStep: string,
    formStepName: string,
    formStatus: Array<string> = [],
    outcome: string = undefined,
) => ({
    siteStructure: [
        'privatkunden', 'mobilfunk', 'mehr fuer dich', 'ausland & roaming', 'fuer vertragskunden', 'roaming advisor', formStepName,
    ],
    pageType: 'service',
    siteArea: 'mobility',
    loginStatus: 'not logged in',
    platformType: 'responsive',

    oForm: {
        name: 'roaming advisor',
        type: 'application funnel',
        formStep,
        formStepName,
        formStatus,
        ...(outcome) && { outcome },
    },
});
